export const slugify = (str) => {
  var regex4 = /[*+~.(),'"!:@]/g;
  return str
    .toLowerCase()
    .replace(regex4, '')
    .replace(/\s/g, '-');
};
